import { Grid, TextField } from "@material-ui/core";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { CustomNumericFormat } from "./CustomNumericFormat";
import { ListingDialogInputSelects } from "../form/ListingDialogInputSelects";
import type { PropsWithChildren } from "react";
import type { EditableListing } from "../../../../../@types/listings/new";

type ListingDialogConditionalInputsProps = PropsWithChildren<{
  loading: boolean;
  editableFormColumns: EditableListing;
  handleChange: ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => void;
}>;

export function ListingDialogConditionalInputs({
  loading,
  editableFormColumns,
  handleChange
}: ListingDialogConditionalInputsProps): JSX.Element {
  const { t: translate } = useTranslation();

  const {
    hasGarden,
    hasParking,
    hasTerrace,
    projectName,
    listingState,
    sizeOfGardenM2,
    sizeOfTerraceM2,
    parkingSpotsCount
  } = editableFormColumns;

  return (
    <>
      {listingState === "newConstruction" && (
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            type="text"
            name="projectName"
            label={translate("listingsPage.tableColumns.projectName")}
            value={projectName}
            disabled={loading}
            onChange={handleChange}
          />
        </Grid>
      )}
      {hasGarden && (
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            disabled={loading}
            label={translate("listingsPage.tableColumns.sizeOfGardenM2")}
            value={sizeOfGardenM2}
            name="sizeOfGardenM2"
            onChange={handleChange}
            InputProps={{
              inputComponent: CustomNumericFormat as never
            }}
          />
        </Grid>
      )}
      {hasParking && (
        <Grid item xs={12} sm={6} md={4}>
          <ListingDialogInputSelects
            name="parkingSpotsCount"
            value={parkingSpotsCount}
            loading={loading}
            handleChange={handleChange}
          />
        </Grid>
      )}
      {hasTerrace && (
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            disabled={loading}
            label={translate("listingsPage.tableColumns.sizeOfTerraceM2")}
            value={sizeOfTerraceM2}
            name="sizeOfTerraceM2"
            onChange={handleChange}
            InputProps={{
              inputComponent: CustomNumericFormat as never
            }}
          />
        </Grid>
      )}
    </>
  );
}
